export function buildEmptyCommissionRecalculationForm() {
  return {
    dateMode: 'all_history',
    dateFrom: '',
    dateTo: '',
  };
}

function normalizeDate(value) {
  return String(value || '').trim();
}

export function validateCommissionRecalculationForm(form) {
  const dateMode = form?.dateMode;
  if (dateMode !== 'date_range') {
    return {};
  }

  const dateFrom = normalizeDate(form?.dateFrom);
  const dateTo = normalizeDate(form?.dateTo);
  const errors = {};

  if (!dateFrom) {
    errors.dateFrom = 'required';
  }

  if (!dateTo) {
    errors.dateTo = 'required';
  }

  if (dateFrom && dateTo && dateFrom > dateTo) {
    errors.dateFrom = 'after_date_to';
    errors.dateTo = 'before_date_from';
  }

  return errors;
}

export function buildCommissionRecalculationPayload(form) {
  if (form?.dateMode === 'date_range') {
    return {
      dateMode: 'date_range',
      dateFrom: normalizeDate(form?.dateFrom),
      dateTo: normalizeDate(form?.dateTo),
    };
  }

  return {
    dateMode: 'all_history',
    dateFrom: null,
    dateTo: null,
  };
}
